<div class="container">
  <div class="grid-row">
    <div class="md-3"></div>
    <div class="xs-12 md-6">
      <div class="card">
        <div class="reference-numbers">
          <h4>Reference numbers</h4>
          <div class="reference-number">
            <p class="label mb-2">Job reference number</p>
            <p>{{ offers?.current_plan?.plan_number }}</p>
          </div>
          <div
            class="reference-number"
            *ngIf="cardPaymentRedirect?.response?.orderNumber"
          >
            <p class="label">Payment ID</p>
            <p>{{ cardPaymentRedirect?.response?.orderNumber }}</p>
          </div>
        </div>
        <div class="delivery-details">
          <h4>Delivery details</h4>
          <div class="delivery-date">
            <p class="label mb-2">Date of delivery</p>
            <p
              class="typog-body"
              *ngIf="
                upfront?.delivery && formData?.delivery?.expectedDate;
                else ServiceProviderWillContact
              "
            >
              {{ dateOfDelivery }}
            </p>
            <ng-template #ServiceProviderWillContact>
              <p class="typog-body">
                The service provider will contact you with more information
                about when your replacement will arrive.
              </p>
            </ng-template>
          </div>
        </div>
        <hr />
        <div class="delivery-address">
          <p class="label mb-2">Delivery address</p>
          <p class="typog-body mb-1" [dgxQmSanitise]="'block'">
            {{ offers?.delivery_address?.address_line_1 }}
          </p>
          <p class="typog-body mb-1" [dgxQmSanitise]="'block'">
            {{ offers?.delivery_address?.address_line_2 }}
          </p>
          <p class="typog-body mb-1" [dgxQmSanitise]="'block'">
            {{ offers?.delivery_address?.address_line_3 }}
          </p>
          <p class="typog-body" [dgxQmSanitise]="'block'">
            {{ offers?.delivery_address?.postal_code }}
          </p>
        </div>
        <hr />
        <div class="flex-space-between">
          <p class="label">Service provider</p>
          <p class="typog-body">{{ selected?.supplier_name }}</p>
        </div>
        <hr />
        <p class="typog-body mb-2 mt-3 purple">
          We've already registered your new appliance with the manufacturer - so
          that's all done for you.
        </p>
        <p class="mb-8">
          We sometimes contact our customers with delivery updates and to check
          that replacements are running smoothly. We also get in touch about
          relevant offers that may interest them. If you’d prefer not to be
          contacted about these offers, let one of our agents know.
        </p>

        <div
          class="billing-details mb-8"
          *ngIf="cardPaymentRedirect?.request?.billingAddress"
        >
          <h4>Billing details</h4>
          <p class="label mb-2">Billing address</p>
          <p class="typog-body" [dgxQmSanitise]="'block'">
            {{ cardPaymentRedirect?.request?.billingAddress?.addressLine1 }}
          </p>
          <p class="typog-body" [dgxQmSanitise]="'block'">
            {{ cardPaymentRedirect?.request?.billingAddress?.addressLine2 }}
          </p>
          <p class="typog-body" [dgxQmSanitise]="'block'">
            {{ cardPaymentRedirect?.request?.billingAddress?.addressLine3 }}
          </p>
          <p
            class="typog-body"
            [dgxQmSanitise]="'block'"
            *ngIf="cardPaymentRedirect?.request?.billingAddress?.addressLine4"
          >
            {{ cardPaymentRedirect?.request?.billingAddress?.addressLine4 }}
          </p>
          <p class="typog-body" [dgxQmSanitise]="'block'">
            {{ cardPaymentRedirect?.request?.billingAddress?.postalCode }}
          </p>
        </div>
        <ng-container *ngIf="upfront?.isProtectionSelected">
          <h4>Your protection policy</h4>
          <p *ngIf="order?.error_status === 201; else summary">
            Something went wrong, you will be contacted to create the new
            policy.
          </p>
          <ng-template #summary>
            <p class="mb-4">
              We'll send you a confirmation email with your policy documents.
            </p>
            <ng-container *ngIf="upfront?.monthlyPayment">
              <div class="flex-space-between">
                <p class="label">Monthly payment</p>
                <p class="typog-body">
                  {{ upfront?.monthlyPayment | currency : 'GBP' }}
                </p>
              </div>
              <hr />
            </ng-container>
            <div class="flex-space-between">
              <p class="label">Policy type</p>
              <p class="typog-body">Continuous cover</p>
            </div>
            <hr />
            <ng-container *ngIf="order?.plan_number">
              <div class="flex-space-between">
                <p class="label">Policy number</p>
                <p class="typog-body">{{ order?.plan_number }}</p>
              </div>
              <hr />
            </ng-container>
            <div class="flex-space-between">
              <p class="label">Payment method</p>
              <p class="typog-body">Direct Debit</p>
            </div>
            <hr />
            <ng-container *ngIf="formData?.directDebit?.preferredPaymentDay">
              <div class="flex-space-between">
                <p class="label">Monthly payment day</p>
                <p class="typog-body">
                  {{ formData?.directDebit?.preferredPaymentDay }}
                </p>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div class="md-3"></div>
  </div>
</div>
